import i18next from 'i18next';
import { Link } from '@tanium/react-link';
import React from 'react';
import { RequestTargetType } from 'gql/Request';
import Helper from 'utils/Helper';
import {
  AWS_ACCOUNT_ROUTE,
  CLUSTER_ROUTE,
  CUSTOMER_ROUTE,
  EOS_SERVICE_ROUTE,
  MS_ENTRA_ID_ROUTE,
  SERVICE_ROUTE,
  TARGET_GROUP_ROUTE,
} from 'Route';

export interface Target {
  targetType: RequestTargetType;
  targetName: string;
  targetId: string;
}

type MediumDefinitionListItemProps = {
  target: Target;
};

const TargetLink: React.VFC<MediumDefinitionListItemProps> = ({ target }) => {
  if (target.targetType === RequestTargetType.AWSAccount) {
    return (
      <Link href={Helper.interpolateRoute(AWS_ACCOUNT_ROUTE.url, { awsAccountObjectId: target.targetId })}>
        <div data-testid="target-link-aws-account" className="truncated-text">
          {i18next.t(target.targetType)}: {target.targetName}
        </div>
      </Link>
    );
  }
  if (target.targetType === RequestTargetType.CustomerEnvironment) {
    return (
      <Link href={Helper.interpolateRoute(CUSTOMER_ROUTE.url, { customerId: target.targetId })}>
        <div data-testid="target-link-customer-environment" className="truncated-text">
          {i18next.t(target.targetType)}: {target.targetName}
        </div>
      </Link>
    );
  }
  if (target.targetType === RequestTargetType.EosService) {
    return (
      <Link href={Helper.interpolateRoute(EOS_SERVICE_ROUTE.url, { eosServiceId: target.targetId })}>
        <div data-testid="target-link-eos-service" className="truncated-text">
          {i18next.t(target.targetType)}: {target.targetName}
        </div>
      </Link>
    );
  }
  if (target.targetType === RequestTargetType.GlobalService) {
    return (
      <Link href={Helper.interpolateRoute(SERVICE_ROUTE.url, { serviceId: target.targetId })}>
        <div data-testid="target-link-global-service" className="truncated-text">
          {i18next.t(target.targetType)}: {target.targetName}
        </div>
      </Link>
    );
  }
  if (target.targetType === RequestTargetType.KubernetesCluster) {
    return (
      <Link href={Helper.interpolateRoute(CLUSTER_ROUTE.url, { clusterId: target.targetId })}>
        <div data-testid="target-link-kubernetes-cluster" className="truncated-text">
          {i18next.t(target.targetType)}: {target.targetName}
        </div>
      </Link>
    );
  }
  if (target.targetType === RequestTargetType.MsEntraID) {
    return (
      <Link href={Helper.interpolateRoute(MS_ENTRA_ID_ROUTE.url, { msEntraIDId: target.targetId })}>
        <div data-testid="target-link-ms-entra-id" className="truncated-text">
          {i18next.t(target.targetType)}: {target.targetName}
        </div>
      </Link>
    );
  }
  if (target.targetType === RequestTargetType.TargetGroup) {
    return (
      <Link href={Helper.interpolateRoute(TARGET_GROUP_ROUTE.url, { targetGroupId: target.targetId })}>
        <div data-testid="target-link-target-group" className="truncated-text">
          {i18next.t(target.targetType)}: {target.targetName}
        </div>
      </Link>
    );
  }
  return (
    <div data-testid="target-link-unknown" className="truncated-text">
      {i18next.t(target.targetType)}: {target.targetId}
    </div>
  );
};

export default TargetLink;
